// Contenu centralisé (i18n-ready). FR par défaut. Structure prête pour DE/EN.
export const IMAGES = {
  heroBand: "https://images.pexels.com/photos/3984822/pexels-photo-3984822.jpeg",
  sax: "https://images.pexels.com/photos/3984801/pexels-photo-3984801.jpeg",
  djMic: "https://images.unsplash.com/photo-1510511233900-1982d92bd835",
  djMix: "https://images.pexels.com/photos/14577027/pexels-photo-14577027.jpeg",
  mixer: "https://images.unsplash.com/photo-1594623930572-300a3011d9ae",
  weddingRoom: "https://images.unsplash.com/photo-1780593194924-35f0343e738b",
  dining: "https://images.pexels.com/photos/36873712/pexels-photo-36873712.jpeg",
};

export const SERVICES = [
  {
    slug: "musique-live",
    title: "Musique live",
    tagline: "L'émotion d'une performance en direct",
    image: IMAGES.sax,
    short: "Animation musicale et interprètes pour accompagner les moments forts de votre événement.",
    benefits: ["Répertoire adaptable", "Ambiance personnalisée", "Accompagnement des temps forts"],
    long: [
      "La musique live apporte une émotion unique à vos événements. Chanteur ou musicien selon la formule, un répertoire adaptable et une ambiance musicale pensée pour vous.",
      "Musique d'accueil, cocktail, dîner, cérémonie, soirée dansante ou animation d'entreprise : nous accompagnons chaque instant important.",
    ],
    points: ["Animation musicale", "Chanteur ou musicien selon la formule", "Répertoire adaptable", "Musique d'accueil & cocktail", "Cérémonie & dîner", "Soirée dansante", "Animation d'entreprise"],
  },
  {
    slug: "dj",
    title: "DJing",
    tagline: "Le tempo parfait, du début à la fin",
    image: IMAGES.djMix,
    short: "Un DJ qui lit votre public et rythme chaque temps fort avec élégance et énergie.",
    benefits: ["Ambiance sur-mesure", "Adaptation au public", "Matériel professionnel"],
    long: [
      "Nos prestations de DJ s'adaptent à tous les événements : mariages, anniversaires, soirées privées, événements d'entreprise, galas, festivals et soirées associatives.",
      "Préparation personnalisée de l'ambiance, adaptation musicale au public, gestion des temps forts et coordination avec les organisateurs. Le DJing peut être combiné à la musique live.",
    ],
    points: ["Préparation personnalisée de l'ambiance", "Adaptation musicale au public", "Gestion des temps forts", "Coordination avec les organisateurs", "Matériel professionnel", "Animation élégante et dynamique", "Combinable avec la musique live"],
  },
  {
    slug: "location-materiel",
    title: "Location de matériel",
    tagline: "Un son et une lumière à la hauteur",
    image: IMAGES.mixer,
    short: "Sonorisation, éclairage et équipements professionnels pour vos événements privés ou pro.",
    benefits: ["Matériel professionnel", "Livraison & installation", "Technicien en option"],
    long: [
      "Nous proposons la location de matériel événementiel : sonorisation, enceintes, microphones, tables de mixage, éclairage d'ambiance et de soirée, équipements DJ et accessoires techniques.",
      "Location seule, avec livraison, avec installation, prestation complète avec technicien ou récupération du matériel : des options modulables selon vos besoins.",
    ],
    points: ["Sonorisation & enceintes", "Microphones", "Tables de mixage", "Éclairage d'ambiance & de soirée", "Équipements DJ", "Accessoires techniques", "Livraison, installation & technicien en option"],
  },
];

export const PARTNER_SERVICES = [
  { title: "Décoration événementielle", desc: "Conception d'ambiance, décoration de salle et de table, arches, espaces photos et installations décoratives coordonnées à votre thème.", icon: "Sparkles" },
  { title: "Location de matériel décoratif", desc: "Mobilier événementiel, éléments décoratifs, structures, nappage, éclairage décoratif et accessoires de cérémonie.", icon: "Armchair" },
  { title: "Photographe", desc: "Reportage événementiel, photographies de mariage, portraits et captation des moments importants.", icon: "Camera" },
  { title: "Vidéographe", desc: "Captation vidéo, film événementiel, résumé vidéo et contenus pour vos réseaux sociaux.", icon: "Video" },
];

export const FORMULAS = [
  "Musique live + DJ",
  "DJ + sonorisation",
  "Musique live + matériel",
  "Prestation musicale + décoration partenaire",
  "Formule complète personnalisée",
];

export const EVENT_TYPES = [
  { id: "mariage", label: "Mariage" },
  { id: "anniversaire", label: "Anniversaire" },
  { id: "bapteme-communion", label: "Baptême ou communion" },
  { id: "soiree-privee", label: "Soirée privée" },
  { id: "entreprise", label: "Événement d'entreprise" },
  { id: "association", label: "Association ou collectivité" },
  { id: "concert-festival", label: "Concert ou festival" },
  { id: "autre", label: "Autre événement" },
];

export const METHOD_STEPS = [
  { n: "01", title: "Vous décrivez votre événement", desc: "Partagez votre projet, votre lieu et l'ambiance recherchée." },
  { n: "02", title: "Nous étudions vos besoins", desc: "Nous analysons chaque détail pour vous conseiller au mieux." },
  { n: "03", title: "Vous recevez une proposition", desc: "Une offre personnalisée et transparente, sans engagement." },
  { n: "04", title: "Nous préparons ensemble", desc: "Coordination, matériel et déroulé calés avec vous." },
  { n: "05", title: "Nous accompagnons la réussite", desc: "Le jour J, KMR Event veille à la magie de votre événement." },
];

export const QUOTE_SERVICES = [
  "Musique live", "DJ", "Sonorisation", "Éclairage", "Location de matériel",
  "Installation technique", "Décoration (partenaire)", "Matériel décoratif (partenaire)",
  "Photographe (partenaire)", "Vidéographe (partenaire)", "Accompagnement personnalisé", "Autre besoin",
];

export const STATUS_LABELS = {
  nouvelle: "Nouvelle",
  a_rappeler: "À rappeler",
  en_cours: "En cours d'étude",
  proposition_envoyee: "Proposition envoyée",
  confirmee: "Confirmée",
  refusee: "Refusée",
  archivee: "Archivée",
};

export const VALUES = [
  "Professionnalisme", "Élégance", "Énergie", "Créativité",
  "Fiabilité", "Proximité", "Flexibilité", "Accompagnement personnalisé",
];
